// src/constants/voiceData.js
// Generated from uploaded Excel files

export const viduVoices = [
  {
    "value": "male-qn-qingse",
    "label": "青涩青年音色",
    "lang": "zh"
  },
  {
    "value": "male-qn-jingying",
    "label": "精英青年音色",
    "lang": "zh"
  },
  {
    "value": "male-qn-badao",
    "label": "霸道青年音色",
    "lang": "zh"
  },
  {
    "value": "male-qn-daxuesheng",
    "label": "青年大学生音色",
    "lang": "zh"
  },
  {
    "value": "female-shaonv",
    "label": "少女音色",
    "lang": "zh"
  },
  {
    "value": "female-yujie",
    "label": "御姐音色",
    "lang": "zh"
  },
  {
    "value": "female-chengshu",
    "label": "成熟女性音色",
    "lang": "zh"
  },
  {
    "value": "female-tianmei",
    "label": "甜美女性音色",
    "lang": "zh"
  },
  {
    "value": "male-qn-qingse-jingpin",
    "label": "青涩青年音色-beta",
    "lang": "zh"
  },
  {
    "value": "male-qn-jingying-jingpin",
    "label": "精英青年音色-beta",
    "lang": "zh"
  },
  {
    "value": "male-qn-badao-jingpin",
    "label": "霸道青年音色-beta",
    "lang": "zh"
  },
  {
    "value": "male-qn-daxuesheng-jingpin",
    "label": "青年大学生音色-beta",
    "lang": "zh"
  },
  {
    "value": "female-shaonv-jingpin",
    "label": "少女音色-beta",
    "lang": "zh"
  },
  {
    "value": "female-yujie-jingpin",
    "label": "御姐音色-beta",
    "lang": "zh"
  },
  {
    "value": "female-chengshu-jingpin",
    "label": "成熟女性音色-beta",
    "lang": "zh"
  },
  {
    "value": "female-tianmei-jingpin",
    "label": "甜美女性音色-beta",
    "lang": "zh"
  },
  {
    "value": "clever_boy",
    "label": "聪明男童",
    "lang": "zh"
  },
  {
    "value": "cute_boy",
    "label": "可爱男童",
    "lang": "zh"
  },
  {
    "value": "lovely_girl",
    "label": "萌萌女童",
    "lang": "zh"
  },
  {
    "value": "cartoon_pig",
    "label": "卡通猪小琪",
    "lang": "zh"
  },
  {
    "value": "bingjiao_didi",
    "label": "病娇弟弟",
    "lang": "zh"
  },
  {
    "value": "junlang_nanyou",
    "label": "俊朗男友",
    "lang": "zh"
  },
  {
    "value": "chunzhen_xuedi",
    "label": "纯真学弟",
    "lang": "zh"
  },
  {
    "value": "lengdan_xiongzhang",
    "label": "冷淡学长",
    "lang": "zh"
  },
  {
    "value": "badao_shaoye",
    "label": "霸道少爷",
    "lang": "zh"
  },
  {
    "value": "tianxin_xiaoling",
    "label": "甜心小玲",
    "lang": "zh"
  },
  {
    "value": "qiaopi_mengmei",
    "label": "俏皮萌妹",
    "lang": "zh"
  },
  {
    "value": "wumei_yujie",
    "label": "妩媚御姐",
    "lang": "zh"
  },
  {
    "value": "diadia_xuemei",
    "label": "嗲嗲学妹",
    "lang": "zh"
  },
  {
    "value": "danya_xuejie",
    "label": "淡雅学姐",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Reliable_Executive",
    "label": "沉稳高管",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_News_Anchor",
    "label": "新闻女声",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Mature_Woman",
    "label": "傲娇御姐",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Unrestrained_Young_Man",
    "label": "不羁青年",
    "lang": "zh"
  },
  {
    "value": "Arrogant_Miss",
    "label": "嚣张小姐",
    "lang": "zh"
  },
  {
    "value": "Robot_Armor",
    "label": "机械战甲",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Kind-hearted_Antie",
    "label": "热心大婶",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_HK_Flight_Attendant",
    "label": "港普空姐",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Humorous_Elder",
    "label": "搞笑大爷",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Gentleman",
    "label": "温润男声",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Warm_Bestie",
    "label": "温暖闺蜜",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Male_Announcer",
    "label": "播报男声",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Sweet_Lady",
    "label": "甜美女声",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Southern_Young_Man",
    "label": "南方小哥",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Wise_Women",
    "label": "阅历姐姐",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Gentle_Youth",
    "label": "温润青年",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Warm_Girl",
    "label": "温暖少女",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Kind-hearted_Elder",
    "label": "花甲奶奶",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Cute_Spirit",
    "label": "憨憨萌兽",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Radio_Host",
    "label": "电台男主播",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Lyrical_Voice",
    "label": "抒情男声",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Straightforward_Boy",
    "label": "率真弟弟",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Sincere_Adult",
    "label": "真诚青年",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Gentle_Senior",
    "label": "温柔学姐",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Stubborn_Friend",
    "label": "嘴硬竹马",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Crisp_Girl",
    "label": "清脆少女",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Pure-hearted_Boy",
    "label": "清澈邻家弟弟",
    "lang": "zh"
  },
  {
    "value": "Chinese (Mandarin)_Soft_Girl",
    "label": "软软女孩",
    "lang": "zh"
  },
  {
    "value": "Cantonese_ProfessionalHost（F)",
    "label": "专业女主持",
    "lang": "zh"
  },
  {
    "value": "Cantonese_GentleLady",
    "label": "温柔女声",
    "lang": "zh"
  },
  {
    "value": "Cantonese_ProfessionalHost（M)",
    "label": "专业男主持",
    "lang": "zh"
  },
  {
    "value": "Cantonese_PlayfulMan",
    "label": "活泼男声",
    "lang": "zh"
  },
  {
    "value": "Cantonese_CuteGirl",
    "label": "可爱女孩",
    "lang": "zh"
  },
  {
    "value": "Cantonese_KindWoman",
    "label": "善良女声",
    "lang": "zh"
  },
  {
    "value": "Grinch",
    "label": "Grinch",
    "lang": "en"
  },
  {
    "value": "Rudolph",
    "label": "Rudolph",
    "lang": "en"
  },
  {
    "value": "Arnold",
    "label": "Arnold",
    "lang": "en"
  },
  {
    "value": "Charming_Santa",
    "label": "Charming Santa",
    "lang": "en"
  },
  {
    "value": "Charming_Lady",
    "label": "Charming Lady",
    "lang": "en"
  },
  {
    "value": "Sweet_Girl",
    "label": "Sweet Girl",
    "lang": "en"
  },
  {
    "value": "Cute_Elf",
    "label": "Cute Elf",
    "lang": "en"
  },
  {
    "value": "Attractive_Girl",
    "label": "Attractive Girl",
    "lang": "en"
  },
  {
    "value": "Serene_Woman",
    "label": "Serene Woman",
    "lang": "en"
  },
  {
    "value": "English_Trustworthy_Man",
    "label": "Trustworthy Man",
    "lang": "en"
  },
  {
    "value": "English_Graceful_Lady",
    "label": "Graceful Lady",
    "lang": "en"
  },
  {
    "value": "English_Aussie_Bloke",
    "label": "Aussie Bloke",
    "lang": "en"
  },
  {
    "value": "English_Whispering_girl",
    "label": "Whispering girl",
    "lang": "en"
  },
  {
    "value": "English_Diligent_Man",
    "label": "Diligent Man",
    "lang": "en"
  },
  {
    "value": "English_Gentle-voiced_man",
    "label": "Gentle-voiced man",
    "lang": "en"
  },
  {
    "value": "Japanese_IntellectualSenior",
    "label": "Intellectual Senior",
    "lang": "en"
  },
  {
    "value": "Japanese_DecisivePrincess",
    "label": "Decisive Princess",
    "lang": "en"
  },
  {
    "value": "Japanese_LoyalKnight",
    "label": "Loyal Knight",
    "lang": "en"
  },
  {
    "value": "Japanese_DominantMan",
    "label": "Dominant Man",
    "lang": "en"
  },
  {
    "value": "Japanese_SeriousCommander",
    "label": "Serious Commander",
    "lang": "en"
  },
  {
    "value": "Japanese_ColdQueen",
    "label": "Cold Queen",
    "lang": "en"
  },
  {
    "value": "Japanese_DependableWoman",
    "label": "Dependable Woman",
    "lang": "en"
  },
  {
    "value": "Japanese_GentleButler",
    "label": "Gentle Butler",
    "lang": "en"
  },
  {
    "value": "Japanese_KindLady",
    "label": "Kind Lady",
    "lang": "en"
  },
  {
    "value": "Japanese_CalmLady",
    "label": "Calm Lady",
    "lang": "en"
  },
  {
    "value": "Japanese_OptimisticYouth",
    "label": "Optimistic Youth",
    "lang": "en"
  },
  {
    "value": "Japanese_GenerousIzakayaOwner",
    "label": "Generous Izakaya Owner",
    "lang": "en"
  },
  {
    "value": "Japanese_SportyStudent",
    "label": "Sporty Student",
    "lang": "en"
  },
  {
    "value": "Japanese_InnocentBoy",
    "label": "Innocent Boy",
    "lang": "en"
  },
  {
    "value": "Japanese_GracefulMaiden",
    "label": "Graceful Maiden",
    "lang": "en"
  },
  {
    "value": "Korean_SweetGirl",
    "label": "Sweet Girl",
    "lang": "en"
  },
  {
    "value": "Korean_CheerfulBoyfriend",
    "label": "Cheerful Boyfriend",
    "lang": "en"
  },
  {
    "value": "Korean_EnchantingSister",
    "label": "Enchanting Sister",
    "lang": "en"
  },
  {
    "value": "Korean_ShyGirl",
    "label": "Shy Girl",
    "lang": "en"
  },
  {
    "value": "Korean_ReliableSister",
    "label": "Reliable Sister",
    "lang": "en"
  },
  {
    "value": "Korean_StrictBoss",
    "label": "Strict Boss",
    "lang": "en"
  },
  {
    "value": "Korean_SassyGirl",
    "label": "Sassy Girl",
    "lang": "en"
  },
  {
    "value": "Korean_ChildhoodFriendGirl",
    "label": "Childhood Friend Girl",
    "lang": "en"
  },
  {
    "value": "Korean_PlayboyCharmer",
    "label": "Playboy Charmer",
    "lang": "en"
  },
  {
    "value": "Korean_ElegantPrincess",
    "label": "Elegant Princess",
    "lang": "en"
  },
  {
    "value": "Korean_BraveFemaleWarrior",
    "label": "Brave Female Warrior",
    "lang": "en"
  },
  {
    "value": "Korean_BraveYouth",
    "label": "Brave Youth",
    "lang": "en"
  },
  {
    "value": "Korean_CalmLady",
    "label": "Calm Lady",
    "lang": "en"
  },
  {
    "value": "Korean_EnthusiasticTeen",
    "label": "Enthusiastic Teen",
    "lang": "en"
  },
  {
    "value": "Korean_SoothingLady",
    "label": "Soothing Lady",
    "lang": "en"
  },
  {
    "value": "Korean_IntellectualSenior",
    "label": "Intellectual Senior",
    "lang": "en"
  },
  {
    "value": "Korean_LonelyWarrior",
    "label": "Lonely Warrior",
    "lang": "en"
  },
  {
    "value": "Korean_MatureLady",
    "label": "Mature Lady",
    "lang": "en"
  },
  {
    "value": "Korean_InnocentBoy",
    "label": "Innocent Boy",
    "lang": "en"
  },
  {
    "value": "Korean_CharmingSister",
    "label": "Charming Sister",
    "lang": "en"
  },
  {
    "value": "Korean_AthleticStudent",
    "label": "Athletic Student",
    "lang": "en"
  },
  {
    "value": "Korean_BraveAdventurer",
    "label": "Brave Adventurer",
    "lang": "en"
  },
  {
    "value": "Korean_CalmGentleman",
    "label": "Calm Gentleman",
    "lang": "en"
  },
  {
    "value": "Korean_WiseElf",
    "label": "Wise Elf",
    "lang": "en"
  },
  {
    "value": "Korean_CheerfulCoolJunior",
    "label": "Cheerful Cool Junior",
    "lang": "en"
  },
  {
    "value": "Korean_DecisiveQueen",
    "label": "Decisive Queen",
    "lang": "en"
  },
  {
    "value": "Korean_ColdYoungMan",
    "label": "Cold Young Man",
    "lang": "en"
  },
  {
    "value": "Korean_MysteriousGirl",
    "label": "Mysterious Girl",
    "lang": "en"
  },
  {
    "value": "Korean_QuirkyGirl",
    "label": "Quirky Girl",
    "lang": "en"
  },
  {
    "value": "Korean_ConsiderateSenior",
    "label": "Considerate Senior",
    "lang": "en"
  },
  {
    "value": "Korean_CheerfulLittleSister",
    "label": "Cheerful Little Sister",
    "lang": "en"
  },
  {
    "value": "Korean_DominantMan",
    "label": "Dominant Man",
    "lang": "en"
  },
  {
    "value": "Korean_AirheadedGirl",
    "label": "Airheaded Girl",
    "lang": "en"
  },
  {
    "value": "Korean_ReliableYouth",
    "label": "Reliable Youth",
    "lang": "en"
  },
  {
    "value": "Korean_FriendlyBigSister",
    "label": "Friendly Big Sister",
    "lang": "en"
  },
  {
    "value": "Korean_GentleBoss",
    "label": "Gentle Boss",
    "lang": "en"
  },
  {
    "value": "Korean_ColdGirl",
    "label": "Cold Girl",
    "lang": "en"
  },
  {
    "value": "Korean_HaughtyLady",
    "label": "Haughty Lady",
    "lang": "en"
  },
  {
    "value": "Korean_CharmingElderSister",
    "label": "Charming Elder Sister",
    "lang": "en"
  },
  {
    "value": "Korean_IntellectualMan",
    "label": "Intellectual Man",
    "lang": "en"
  },
  {
    "value": "Korean_CaringWoman",
    "label": "Caring Woman",
    "lang": "en"
  },
  {
    "value": "Korean_WiseTeacher",
    "label": "Wise Teacher",
    "lang": "en"
  },
  {
    "value": "Korean_ConfidentBoss",
    "label": "Confident Boss",
    "lang": "en"
  },
  {
    "value": "Korean_AthleticGirl",
    "label": "Athletic Girl",
    "lang": "en"
  },
  {
    "value": "Korean_PossessiveMan",
    "label": "Possessive Man",
    "lang": "en"
  },
  {
    "value": "Korean_GentleWoman",
    "label": "Gentle Woman",
    "lang": "en"
  },
  {
    "value": "Korean_CockyGuy",
    "label": "Cocky Guy",
    "lang": "en"
  },
  {
    "value": "Korean_ThoughtfulWoman",
    "label": "Thoughtful Woman",
    "lang": "en"
  },
  {
    "value": "Korean_OptimisticYouth",
    "label": "Optimistic Youth",
    "lang": "en"
  },
  {
    "value": "Spanish_SereneWoman",
    "label": "Serene Woman",
    "lang": "en"
  },
  {
    "value": "Spanish_MaturePartner",
    "label": "Mature Partner",
    "lang": "en"
  },
  {
    "value": "Spanish_CaptivatingStoryteller",
    "label": "Captivating Storyteller",
    "lang": "en"
  },
  {
    "value": "Spanish_Narrator",
    "label": "Narrator",
    "lang": "en"
  },
  {
    "value": "Spanish_WiseScholar",
    "label": "Wise Scholar",
    "lang": "en"
  },
  {
    "value": "Spanish_Kind-heartedGirl",
    "label": "Kind-hearted Girl",
    "lang": "en"
  },
  {
    "value": "Spanish_DeterminedManager",
    "label": "Determined Manager",
    "lang": "en"
  },
  {
    "value": "Spanish_BossyLeader",
    "label": "Bossy Leader",
    "lang": "en"
  },
  {
    "value": "Spanish_ReservedYoungMan",
    "label": "Reserved Young Man",
    "lang": "en"
  },
  {
    "value": "Spanish_ConfidentWoman",
    "label": "Confident Woman",
    "lang": "en"
  },
  {
    "value": "Spanish_ThoughtfulMan",
    "label": "Thoughtful Man",
    "lang": "en"
  },
  {
    "value": "Spanish_Strong-WilledBoy",
    "label": "Strong-willed Boy",
    "lang": "en"
  },
  {
    "value": "Spanish_SophisticatedLady",
    "label": "Sophisticated Lady",
    "lang": "en"
  },
  {
    "value": "Spanish_RationalMan",
    "label": "Rational Man",
    "lang": "en"
  },
  {
    "value": "Spanish_AnimeCharacter",
    "label": "Anime Character",
    "lang": "en"
  },
  {
    "value": "Spanish_Deep-tonedMan",
    "label": "Deep-toned Man",
    "lang": "en"
  },
  {
    "value": "Spanish_Fussyhostess",
    "label": "Fussy hostess",
    "lang": "en"
  },
  {
    "value": "Spanish_SincereTeen",
    "label": "Sincere Teen",
    "lang": "en"
  },
  {
    "value": "Spanish_FrankLady",
    "label": "Frank Lady",
    "lang": "en"
  },
  {
    "value": "Spanish_Comedian",
    "label": "Comedian",
    "lang": "en"
  },
  {
    "value": "Spanish_Debator",
    "label": "Debator",
    "lang": "en"
  },
  {
    "value": "Spanish_ToughBoss",
    "label": "Tough Boss",
    "lang": "en"
  },
  {
    "value": "Spanish_Wiselady",
    "label": "Wise Lady",
    "lang": "en"
  },
  {
    "value": "Spanish_Steadymentor",
    "label": "Steady Mentor",
    "lang": "en"
  },
  {
    "value": "Spanish_Jovialman",
    "label": "Jovial Man",
    "lang": "en"
  },
  {
    "value": "Spanish_SantaClaus",
    "label": "Santa Claus",
    "lang": "en"
  },
  {
    "value": "Spanish_Rudolph",
    "label": "Rudolph",
    "lang": "en"
  },
  {
    "value": "Spanish_Intonategirl",
    "label": "Intonate Girl",
    "lang": "en"
  },
  {
    "value": "Spanish_Arnold",
    "label": "Arnold",
    "lang": "en"
  },
  {
    "value": "Spanish_Ghost",
    "label": "Ghost",
    "lang": "en"
  },
  {
    "value": "Spanish_HumorousElder",
    "label": "Humorous Elder",
    "lang": "en"
  },
  {
    "value": "Spanish_EnergeticBoy",
    "label": "Energetic Boy",
    "lang": "en"
  },
  {
    "value": "Spanish_WhimsicalGirl",
    "label": "Whimsical Girl",
    "lang": "en"
  },
  {
    "value": "Spanish_StrictBoss",
    "label": "Strict Boss",
    "lang": "en"
  },
  {
    "value": "Spanish_ReliableMan",
    "label": "Reliable Man",
    "lang": "en"
  },
  {
    "value": "Spanish_SereneElder",
    "label": "Serene Elder",
    "lang": "en"
  },
  {
    "value": "Spanish_AngryMan",
    "label": "Angry Man",
    "lang": "en"
  },
  {
    "value": "Spanish_AssertiveQueen",
    "label": "Assertive Queen",
    "lang": "en"
  },
  {
    "value": "Spanish_CaringGirlfriend",
    "label": "Caring Girlfriend",
    "lang": "en"
  },
  {
    "value": "Spanish_PowerfulSoldier",
    "label": "Powerful Soldier",
    "lang": "en"
  },
  {
    "value": "Spanish_PassionateWarrior",
    "label": "Passionate Warrior",
    "lang": "en"
  },
  {
    "value": "Spanish_ChattyGirl",
    "label": "Chatty Girl",
    "lang": "en"
  },
  {
    "value": "Spanish_RomanticHusband",
    "label": "Romantic Husband",
    "lang": "en"
  },
  {
    "value": "Spanish_CompellingGirl",
    "label": "Compelling Girl",
    "lang": "en"
  },
  {
    "value": "Spanish_PowerfulVeteran",
    "label": "Powerful Veteran",
    "lang": "en"
  },
  {
    "value": "Spanish_SensibleManager",
    "label": "Sensible Manager",
    "lang": "en"
  },
  {
    "value": "Spanish_ThoughtfulLady",
    "label": "Thoughtful Lady",
    "lang": "en"
  },
  {
    "value": "Portuguese_SentimentalLady",
    "label": "Sentimental Lady",
    "lang": "en"
  },
  {
    "value": "Portuguese_BossyLeader",
    "label": "Bossy Leader",
    "lang": "en"
  },
  {
    "value": "Portuguese_Wiselady",
    "label": "Wise lady",
    "lang": "en"
  },
  {
    "value": "Portuguese_Strong-WilledBoy",
    "label": "Strong-willed Boy",
    "lang": "en"
  },
  {
    "value": "Portuguese_Deep-VoicedGentleman",
    "label": "Deep-voiced Gentleman",
    "lang": "en"
  },
  {
    "value": "Portuguese_UpsetGirl",
    "label": "Upset Girl",
    "lang": "en"
  },
  {
    "value": "Portuguese_PassionateWarrior",
    "label": "Passionate Warrior",
    "lang": "en"
  },
  {
    "value": "Portuguese_AnimeCharacter",
    "label": "Anime Character",
    "lang": "en"
  },
  {
    "value": "Portuguese_ConfidentWoman",
    "label": "Confident Woman",
    "lang": "en"
  },
  {
    "value": "Portuguese_AngryMan",
    "label": "Angry Man",
    "lang": "en"
  },
  {
    "value": "Portuguese_CaptivatingStoryteller",
    "label": "Captivating Storyteller",
    "lang": "en"
  },
  {
    "value": "Portuguese_Godfather",
    "label": "Godfather",
    "lang": "en"
  },
  {
    "value": "Portuguese_ReservedYoungMan",
    "label": "Reserved Young Man",
    "lang": "en"
  },
  {
    "value": "Portuguese_SmartYoungGirl",
    "label": "Smart Young Girl",
    "lang": "en"
  },
  {
    "value": "Portuguese_Kind-heartedGirl",
    "label": "Kind-hearted Girl",
    "lang": "en"
  },
  {
    "value": "Portuguese_Pompouslady",
    "label": "Pompous lady",
    "lang": "en"
  },
  {
    "value": "Portuguese_Grinch",
    "label": "Grinch",
    "lang": "en"
  },
  {
    "value": "Portuguese_Debator",
    "label": "Debator",
    "lang": "en"
  },
  {
    "value": "Portuguese_SweetGirl",
    "label": "Sweet Girl",
    "lang": "en"
  },
  {
    "value": "Portuguese_AttractiveGirl",
    "label": "Attractive Girl",
    "lang": "en"
  },
  {
    "value": "Portuguese_ThoughtfulMan",
    "label": "Thoughtful Man",
    "lang": "en"
  },
  {
    "value": "Portuguese_PlayfulGirl",
    "label": "Playful Girl",
    "lang": "en"
  },
  {
    "value": "Portuguese_GorgeousLady",
    "label": "Gorgeous Lady",
    "lang": "en"
  },
  {
    "value": "Portuguese_LovelyLady",
    "label": "Lovely Lady",
    "lang": "en"
  },
  {
    "value": "Portuguese_SereneWoman",
    "label": "Serene Woman",
    "lang": "en"
  },
  {
    "value": "Portuguese_SadTeen",
    "label": "Sad Teen",
    "lang": "en"
  },
  {
    "value": "Portuguese_MaturePartner",
    "label": "Mature Partner",
    "lang": "en"
  },
  {
    "value": "Portuguese_Comedian",
    "label": "Comedian",
    "lang": "en"
  },
  {
    "value": "Portuguese_NaughtySchoolgirl",
    "label": "Naughty Schoolgirl",
    "lang": "en"
  },
  {
    "value": "Portuguese_Narrator",
    "label": "Narrator",
    "lang": "en"
  },
  {
    "value": "Portuguese_ToughBoss",
    "label": "Tough Boss",
    "lang": "en"
  },
  {
    "value": "Portuguese_Fussyhostess",
    "label": "Fussy hostess",
    "lang": "en"
  },
  {
    "value": "Portuguese_Dramatist",
    "label": "Dramatist",
    "lang": "en"
  },
  {
    "value": "Portuguese_Steadymentor",
    "label": "Steady Mentor",
    "lang": "en"
  },
  {
    "value": "Portuguese_Jovialman",
    "label": "Jovial Man",
    "lang": "en"
  },
  {
    "value": "Portuguese_CharmingQueen",
    "label": "Charming Queen",
    "lang": "en"
  },
  {
    "value": "Portuguese_SantaClaus",
    "label": "Santa Claus",
    "lang": "en"
  },
  {
    "value": "Portuguese_Rudolph",
    "label": "Rudolph",
    "lang": "en"
  },
  {
    "value": "Portuguese_Arnold",
    "label": "Arnold",
    "lang": "en"
  },
  {
    "value": "Portuguese_CharmingSanta",
    "label": "Charming Santa",
    "lang": "en"
  },
  {
    "value": "Portuguese_CharmingLady",
    "label": "Charming Lady",
    "lang": "en"
  },
  {
    "value": "Portuguese_Ghost",
    "label": "Ghost",
    "lang": "en"
  },
  {
    "value": "Portuguese_HumorousElder",
    "label": "Humorous Elder",
    "lang": "en"
  },
  {
    "value": "Portuguese_CalmLeader",
    "label": "Calm Leader",
    "lang": "en"
  },
  {
    "value": "Portuguese_GentleTeacher",
    "label": "Gentle Teacher",
    "lang": "en"
  },
  {
    "value": "Portuguese_EnergeticBoy",
    "label": "Energetic Boy",
    "lang": "en"
  },
  {
    "value": "Portuguese_ReliableMan",
    "label": "Reliable Man",
    "lang": "en"
  },
  {
    "value": "Portuguese_SereneElder",
    "label": "Serene Elder",
    "lang": "en"
  },
  {
    "value": "Portuguese_GrimReaper",
    "label": "Grim Reaper",
    "lang": "en"
  },
  {
    "value": "Portuguese_AssertiveQueen",
    "label": "Assertive Queen",
    "lang": "en"
  },
  {
    "value": "Portuguese_WhimsicalGirl",
    "label": "Whimsical Girl",
    "lang": "en"
  },
  {
    "value": "Portuguese_StressedLady",
    "label": "Stressed Lady",
    "lang": "en"
  },
  {
    "value": "Portuguese_FriendlyNeighbor",
    "label": "Friendly Neighbor",
    "lang": "en"
  },
  {
    "value": "Portuguese_CaringGirlfriend",
    "label": "Caring Girlfriend",
    "lang": "en"
  },
  {
    "value": "Portuguese_PowerfulSoldier",
    "label": "Powerful Soldier",
    "lang": "en"
  },
  {
    "value": "Portuguese_FascinatingBoy",
    "label": "Fascinating Boy",
    "lang": "en"
  },
  {
    "value": "Portuguese_RomanticHusband",
    "label": "Romantic Husband",
    "lang": "en"
  },
  {
    "value": "Portuguese_StrictBoss",
    "label": "Strict Boss",
    "lang": "en"
  },
  {
    "value": "Portuguese_InspiringLady",
    "label": "Inspiring Lady",
    "lang": "en"
  },
  {
    "value": "Portuguese_PlayfulSpirit",
    "label": "Playful Spirit",
    "lang": "en"
  },
  {
    "value": "Portuguese_ElegantGirl",
    "label": "Elegant Girl",
    "lang": "en"
  },
  {
    "value": "Portuguese_CompellingGirl",
    "label": "Compelling Girl",
    "lang": "en"
  },
  {
    "value": "Portuguese_PowerfulVeteran",
    "label": "Powerful Veteran",
    "lang": "en"
  },
  {
    "value": "Portuguese_SensibleManager",
    "label": "Sensible Manager",
    "lang": "en"
  },
  {
    "value": "Portuguese_ThoughtfulLady",
    "label": "Thoughtful Lady",
    "lang": "en"
  },
  {
    "value": "Portuguese_TheatricalActor",
    "label": "Theatrical Actor",
    "lang": "en"
  },
  {
    "value": "Portuguese_FragileBoy",
    "label": "Fragile Boy",
    "lang": "en"
  },
  {
    "value": "Portuguese_ChattyGirl",
    "label": "Chatty Girl",
    "lang": "en"
  },
  {
    "value": "Portuguese_Conscientiousinstructor",
    "label": "Conscientious Instructor",
    "lang": "en"
  },
  {
    "value": "Portuguese_RationalMan",
    "label": "Rational Man",
    "lang": "en"
  },
  {
    "value": "Portuguese_WiseScholar",
    "label": "Wise Scholar",
    "lang": "en"
  },
  {
    "value": "Portuguese_FrankLady",
    "label": "Frank Lady",
    "lang": "en"
  },
  {
    "value": "Portuguese_DeterminedManager",
    "label": "Determined Manager",
    "lang": "en"
  },
  {
    "value": "French_Male_Speech_New",
    "label": "Level-Headed Man",
    "lang": "en"
  },
  {
    "value": "French_Female_News Anchor",
    "label": "Patient Female Presenter",
    "lang": "en"
  },
  {
    "value": "French_CasualMan",
    "label": "Casual Man",
    "lang": "en"
  },
  {
    "value": "French_MovieLeadFemale",
    "label": "Movie Lead Female",
    "lang": "en"
  },
  {
    "value": "French_FemaleAnchor",
    "label": "Female Anchor",
    "lang": "en"
  },
  {
    "value": "French_MaleNarrator",
    "label": "Male Narrator",
    "lang": "en"
  },
  {
    "value": "Indonesian_SweetGirl",
    "label": "Sweet Girl",
    "lang": "en"
  },
  {
    "value": "Indonesian_ReservedYoungMan",
    "label": "Reserved Young Man",
    "lang": "en"
  },
  {
    "value": "Indonesian_CharmingGirl",
    "label": "Charming Girl",
    "lang": "en"
  },
  {
    "value": "Indonesian_CalmWoman",
    "label": "Calm Woman",
    "lang": "en"
  },
  {
    "value": "Indonesian_ConfidentWoman",
    "label": "Confident Woman",
    "lang": "en"
  },
  {
    "value": "Indonesian_CaringMan",
    "label": "Caring Man",
    "lang": "en"
  },
  {
    "value": "Indonesian_BossyLeader",
    "label": "Bossy Leader",
    "lang": "en"
  },
  {
    "value": "Indonesian_DeterminedBoy",
    "label": "Determined Boy",
    "lang": "en"
  },
  {
    "value": "Indonesian_GentleGirl",
    "label": "Gentle Girl",
    "lang": "en"
  },
  {
    "value": "German_FriendlyMan",
    "label": "Friendly Man",
    "lang": "en"
  },
  {
    "value": "German_SweetLady",
    "label": "Sweet Lady",
    "lang": "en"
  },
  {
    "value": "German_PlayfulMan",
    "label": "Playful Man",
    "lang": "en"
  },
  {
    "value": "Russian_HandsomeChildhoodFriend",
    "label": "Handsome Childhood Friend",
    "lang": "en"
  },
  {
    "value": "Russian_BrightHeroine",
    "label": "Bright Queen",
    "lang": "en"
  },
  {
    "value": "Russian_AmbitiousWoman",
    "label": "Ambitious Woman",
    "lang": "en"
  },
  {
    "value": "Russian_ReliableMan",
    "label": "Reliable Man",
    "lang": "en"
  },
  {
    "value": "Russian_CrazyQueen",
    "label": "Crazy Girl",
    "lang": "en"
  },
  {
    "value": "Russian_PessimisticGirl",
    "label": "Pessimistic Girl",
    "lang": "en"
  },
  {
    "value": "Russian_AttractiveGuy",
    "label": "Attractive Guy",
    "lang": "en"
  },
  {
    "value": "Russian_Bad-temperedBoy",
    "label": "Bad-tempered Boy",
    "lang": "en"
  },
  {
    "value": "Italian_BraveHeroine",
    "label": "Brave Heroine",
    "lang": "en"
  },
  {
    "value": "Italian_Narrator",
    "label": "Narrator",
    "lang": "en"
  },
  {
    "value": "Italian_WanderingSorcerer",
    "label": "Wandering Sorcerer",
    "lang": "en"
  },
  {
    "value": "Italian_DiligentLeader",
    "label": "Diligent Leader",
    "lang": "en"
  },
  {
    "value": "Arabic_CalmWoman",
    "label": "Calm Woman",
    "lang": "en"
  },
  {
    "value": "Arabic_FriendlyGuy",
    "label": "Friendly Guy",
    "lang": "en"
  },
  {
    "value": "Turkish_CalmWoman",
    "label": "Calm Woman",
    "lang": "en"
  },
  {
    "value": "Turkish_Trustworthyman",
    "label": "Trustworthy man",
    "lang": "en"
  },
  {
    "value": "Ukrainian_CalmWoman",
    "label": "Calm Woman",
    "lang": "en"
  },
  {
    "value": "Ukrainian_WiseScholar",
    "label": "Wise Scholar",
    "lang": "en"
  },
  {
    "value": "Dutch_kindhearted_girl",
    "label": "Kind-hearted girl",
    "lang": "en"
  },
  {
    "value": "Dutch_bossy_leader",
    "label": "Bossy leader",
    "lang": "en"
  },
  {
    "value": "Vietnamese_kindhearted_girl",
    "label": "Kind-hearted girl",
    "lang": "en"
  }
];

export const kelingVoices = [
  {
    "value": "genshin_vindi2",
    "label": "阳光少年",
    "lang": "zh"
  },
  {
    "value": "zhinen_xuesheng",
    "label": "懂事小弟",
    "lang": "zh"
  },
  {
    "value": "tiyuxi_xuedi",
    "label": "运动少年",
    "lang": "zh"
  },
  {
    "value": "ai_shatang",
    "label": "青春少女",
    "lang": "zh"
  },
  {
    "value": "genshin_klee2",
    "label": "温柔小妹",
    "lang": "zh"
  },
  {
    "value": "genshin_kirara",
    "label": "元气少女",
    "lang": "zh"
  },
  {
    "value": "ai_kaiya",
    "label": "阳光男生",
    "lang": "zh"
  },
  {
    "value": "tiexin_nanyou",
    "label": "幽默小哥",
    "lang": "zh"
  },
  {
    "value": "ai_chenjiahao_712",
    "label": "文艺小哥",
    "lang": "zh"
  },
  {
    "value": "girlfriend_1_speech02",
    "label": "甜美邻家",
    "lang": "zh"
  },
  {
    "value": "chat1_female_new-3",
    "label": "温柔姐姐",
    "lang": "zh"
  },
  {
    "value": "girlfriend_2_speech02",
    "label": "职场女青",
    "lang": "zh"
  },
  {
    "value": "cartoon-boy-07",
    "label": "活泼男童",
    "lang": "zh"
  },
  {
    "value": "cartoon-girl-01",
    "label": "俏皮女童",
    "lang": "zh"
  },
  {
    "value": "ai_huangyaoshi_712",
    "label": "稳重老爸",
    "lang": "zh"
  },
  {
    "value": "you_pingjing",
    "label": "温柔妈妈",
    "lang": "zh"
  },
  {
    "value": "ai_laoguowang_712",
    "label": "严肃上司",
    "lang": "zh"
  },
  {
    "value": "chengshu_jiejie",
    "label": "优雅贵妇",
    "lang": "zh"
  },
  {
    "value": "zhuxi_speech02",
    "label": "慈祥爷爷",
    "lang": "zh"
  },
  {
    "value": "uk_oldman3",
    "label": "唠叨爷爷",
    "lang": "zh"
  },
  {
    "value": "laopopo_speech02",
    "label": "唠叨奶奶",
    "lang": "zh"
  },
  {
    "value": "heainainai_speech02",
    "label": "和蔼奶奶",
    "lang": "zh"
  },
  {
    "value": "dongbeilaotie_speech02",
    "label": "东北老铁",
    "lang": "zh"
  },
  {
    "value": "chongqingxiaohuo_speech02",
    "label": "重庆小伙",
    "lang": "zh"
  },
  {
    "value": "chuanmeizi_speech02",
    "label": "川妹子",
    "lang": "zh"
  },
  {
    "value": "beijingdama_speech02",
    "label": "北京大妈",
    "lang": "zh"
  },
  {
    "value": "beijingdaye_speech02",
    "label": "北京大爷",
    "lang": "zh"
  },
  {
    "value": "taiwan_female_speech02",
    "label": "台湾女生",
    "lang": "zh"
  },
  {
    "value": "taiwan_male_speech02",
    "label": "台湾男生",
    "lang": "zh"
  },
  {
    "value": "guangdong_female_speech02",
    "label": "广东女生",
    "lang": "zh"
  },
  {
    "value": "guangdong_male_speech02",
    "label": "广东男生",
    "lang": "zh"
  },
  {
    "value": "oversea_male1",
    "label": "播音男声",
    "lang": "en"
  },
  {
    "value": "chat_0407_5-1",
    "label": "知性御姐",
    "lang": "en"
  },
  {
    "value": "girlfriend_4_speech02",
    "label": "温柔女友",
    "lang": "en"
  },
  {
    "value": "uk_boy1",
    "label": "英国男孩",
    "lang": "en"
  },
  {
    "value": "korean_male1",
    "label": "韩语男声",
    "lang": "en"
  },
  {
    "value": "korean_female1",
    "label": "韩语女声",
    "lang": "en"
  },
  {
    "value": "japanese_female1",
    "label": "日语女声",
    "lang": "en"
  },
  {
    "value": "japanese_male1",
    "label": "日语男声",
    "lang": "en"
  },
  {
    "value": "spanish_male1",
    "label": "西语男声",
    "lang": "en"
  },
  {
    "value": "spanish_female1",
    "label": "西语女声",
    "lang": "en"
  },
  {
    "value": "french_male1",
    "label": "法语男声",
    "lang": "en"
  },
  {
    "value": "french_female1",
    "label": "法语女声",
    "lang": "en"
  },
  {
    "value": "german_female1",
    "label": "德语女声",
    "lang": "en"
  },
  {
    "value": "german_male1",
    "label": "德语男声",
    "lang": "en"
  },
  {
    "value": "italian_male1",
    "label": "意语男声",
    "lang": "en"
  },
  {
    "value": "italian_female1",
    "label": "意语女声",
    "lang": "en"
  },
  {
    "value": "russian_female1",
    "label": "俄语女声",
    "lang": "en"
  },
  {
    "value": "russian_male1",
    "label": "俄语男声",
    "lang": "en"
  },
  {
    "value": "portuguese_female1",
    "label": "葡语女声",
    "lang": "en"
  },
  {
    "value": "portuguese_male1",
    "label": "葡语男声",
    "lang": "en"
  },
  {
    "value": "thai_female1",
    "label": "泰语女声",
    "lang": "en"
  },
  {
    "value": "thai_male1",
    "label": "泰语男声",
    "lang": "en"
  },
  {
    "value": "indonesian_female1",
    "label": "印尼女声",
    "lang": "en"
  },
  {
    "value": "indonesian_male1",
    "label": "印尼男声",
    "lang": "en"
  },
  {
    "value": "hindi_female1",
    "label": "印地女声",
    "lang": "en"
  },
  {
    "value": "hindi_male1",
    "label": "印地男声",
    "lang": "en"
  },
  {
    "value": "vietnamese_female1",
    "label": "越南女声",
    "lang": "en"
  },
  {
    "value": "vietnamese_male1",
    "label": "越南男声",
    "lang": "en"
  },
  {
    "value": "malay_female1",
    "label": "马来女声",
    "lang": "en"
  },
  {
    "value": "malay_male1",
    "label": "马来男声",
    "lang": "en"
  },
  {
    "value": "filipino_female1",
    "label": "菲律宾女声",
    "lang": "en"
  },
  {
    "value": "filipino_male1",
    "label": "菲律宾男声",
    "lang": "en"
  }
];